import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { FieldText } from "../FieldText";

export const PartidaUsuario = ({
  metadataTable,
  partida,
}) => {

  return (
    <S.Tr>
      {metadataTable.map((field) => {
        const type = field.tipo;
        const idField = field.nombreCampo;
        const value = partida[field.nombreCampo] || "";
        const required = field.requerido;

        switch (type) {
          case "text":
          default:
            return (
              <S.Td key={idField} title={value}>
                <FieldText
                  id={idField}
                  value={value}
                  readOnly={true}
                  required={required}
                />
              </S.Td>
            );

          case "bool":
            return (
              <S.Td key={idField}>
                <FieldText
                  id={idField}
                  value={value ? "Sí" : "No"}
                  readOnly={true}
                  required={required}
                />
              </S.Td>
            );
        }
      })}
    </S.Tr>
  );
};

PartidaUsuario.propTypes = {
  metadataTable: PropTypes.array,
  partida: PropTypes.object,
};
